import React from 'react'
import { ReactComponent as SphereHalf } from '../../images/pricing/new/sphere-half.svg'
import { ReactComponent as ShooterLongLight } from '../../images/pricing/new/shooter-long-light.svg'
import { ReactComponent as AvatarLineLightswitch } from '../../images/pricing/new/avatar-line-lightswitch.svg'
import { ReactComponent as Lightswitch } from '../../images/pricing/new/lightswitch.svg'
import { ReactComponent as VerticalLine } from '../../images/pricing/new/vertical-line.svg'
import './styles.scss'

const StatsBlock = ({ data }) => {
  const {
    items,
    primary: { why_ld_title: title, why_ld_sub_title: subtitle, why_ld_tagline: tagline }
  } = data[0]

  return (
    <div className="stats-block">
      <div className="stars-mid-body" />
      <div className="pricing-stats-block-group">
        <SphereHalf className="pricing-sphere" />
        <ShooterLongLight className="pricing-shooter-long-light" />
        <AvatarLineLightswitch className="pricing-avatar-line-light-switch" />
        <Lightswitch className="pricing-light-switch" />
        <VerticalLine className="pricing-vertical-line" />
      </div>
      <div className="container">
        <div className="stats-block-heading-group">
          <h6>{subtitle.text}</h6>
          <h2>{title.text}</h2>
          <p>{tagline.text}</p>
        </div>
        <div className="stats-block-stats-group">
          {items.map((stat) => {
            const { stats_number: number, stats_description: desc } = stat
            return (
              <div key={number.text} className="stats-block-stats">
                <div className="stats-block-stats-inner">
                  <h3>{number.text}</h3>
                  <h5>{desc.text}</h5>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default StatsBlock
